import { render, staticRenderFns } from "./ChangeRcj.vue?vue&type=template&id=0494d21c&scoped=true"
import script from "./ChangeRcj.vue?vue&type=script&lang=js"
export * from "./ChangeRcj.vue?vue&type=script&lang=js"
import style0 from "./ChangeRcj.vue?vue&type=style&index=0&id=0494d21c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494d21c",
  null
  
)

export default component.exports